var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOctogan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_13846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 5.33325V7.99992M8.00065 10.6666H8.00732M1.33398 5.68175V10.3181C1.33398 10.4812 1.33398 10.5627 1.3524 10.6394C1.36874 10.7074 1.39567 10.7725 1.43222 10.8321C1.47345 10.8994 1.5311 10.957 1.6464 11.0723L4.92823 14.3542C5.04353 14.4695 5.10118 14.5271 5.16846 14.5683C5.22811 14.6049 5.29314 14.6318 5.36116 14.6482C5.43789 14.6666 5.51942 14.6666 5.68248 14.6666H10.3188C10.4819 14.6666 10.5634 14.6666 10.6401 14.6482C10.7082 14.6318 10.7732 14.6049 10.8328 14.5683C10.9001 14.5271 10.9578 14.4695 11.0731 14.3542L14.3549 11.0723C14.4702 10.957 14.5279 10.8994 14.5691 10.8321C14.6056 10.7725 14.6326 10.7074 14.6489 10.6394C14.6673 10.5627 14.6673 10.4812 14.6673 10.3181V5.68175C14.6673 5.51869 14.6673 5.43716 14.6489 5.36043C14.6326 5.29241 14.6056 5.22738 14.5691 5.16773C14.5279 5.10045 14.4702 5.0428 14.3549 4.9275L11.0731 1.64567C10.9578 1.53037 10.9001 1.47272 10.8328 1.43149C10.7732 1.39494 10.7082 1.368 10.6401 1.35167C10.5634 1.33325 10.4819 1.33325 10.3188 1.33325H5.68248C5.51942 1.33325 5.43789 1.33325 5.36116 1.35167C5.29314 1.368 5.22811 1.39494 5.16846 1.43149C5.10118 1.47272 5.04353 1.53037 4.92823 1.64567L1.6464 4.9275C1.5311 5.0428 1.47345 5.10045 1.43222 5.16773C1.39567 5.22738 1.36874 5.29241 1.3524 5.36043C1.33398 5.43716 1.33398 5.51869 1.33398 5.68175Z",
    stroke: "#F7591B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_13846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOctogan);
export default __webpack_public_path__ + "static/media/AlertOctogan.16394f9540fcfd674505b34d34a749a4.svg";
export { ForwardRef as ReactComponent };